<!-- フッターナビ アイテム -->
<template>
  <li
    class="crly-m-common-footer-nav-item crly-icon"
    :class="[
      item.type,
      { on: showSearchMenu && item.type == 'search' },
      { favorite_click: active && item.type == 'favorite' }
    ]"
    @click="clickFooterNavItem"
  >
    <span class="crly-icon-txt"></span>
  </li>
</template>

<script>
export default {
  name: "CrlyMoleculesCommonFooterNavItem",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    /**
     * 検索メニューの表示状態
     */
    showSearchMenu: {
      type: Boolean,
      default: () => ({})
    }
  },
  computed: {
    active() {
      if (
        this.$route.name === "CrlyFavorite" ||
        this.$route.name === "CrlyFavoriteLift"
      ) {
        return true;
      }
      return false;
    }
  },
  methods: {
    /**
     * クリックイベント
     */
    clickFooterNavItem() {
      if (this.item.type == "search")
        this.$store.commit("menuStatus/setCategoryMenu", true);
      this.$emit("clickFooterNavItem", this.item);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/molecules/common/footerNavItem.scss";
</style>
